var bundleitemcnt = parseInt($('.byob-preview').attr('data-bundleitemcnt'));

$('.collection-byob-product-item').each(function () {
    var $productItem = $(this);
    var $checkbox = $productItem.find('.collection-byob-product-item-checkbox');

    if($productItem.find('.collectionByobProductJson').length > 0){
      // Get product JSON
      var productData = JSON.parse($productItem.find('.collectionByobProductJson').text()).product;
  
      // All swatch radios inside this product
      var $swatches = $productItem.find('.byob-product-item-block-swatch__radio, .byob-product-item-color-swatch__radio');
  
      // Update variant ID
      function updateSelectedVariantId() {
          var selectedOptions = [];
  
          // Loop through each product option index
          productData.options.forEach(function(option, index) {
              var optionPosition = index + 1;
  
              // Get checked radio for this option
              var $checkedSwatch = $productItem.find('[data-option-position="' + optionPosition + '"]:checked');
  
              if ($checkedSwatch.length) {
                  // 👉 USE THE INPUT VALUE DIRECTLY
                  selectedOptions.push($checkedSwatch.val().trim());
              }
          });
  
          // Match variant
          var matchedVariant = productData.variants.find(function (variant) {
              return JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
          });
  
          if (matchedVariant) {
              $checkbox.attr('data-variant-id', matchedVariant.id);
              console.log("✔ Updated variant:", matchedVariant.id, productData.title);
          } else {
              console.log("❌ No matching variant for:", selectedOptions);
          }
      }
  
      // Run once
      updateSelectedVariantId();
  
      // Run on swatch change
      $swatches.on('change', function () {
          updateSelectedVariantId();
      });
    }

});

$(document).ready(function(){
    // BYOB START
    var addedcnt = 0;
    var bundle_price = 0;
    var bundle_compare_price = 0;
    
    
    function disableAddedVariantButtons() {
      // console.log('disableAddedVariantButtons');
      $('.byob-preview_item[data-vid]').each(function() {
        const id = $(this).attr('data-vid');
        $(`.byob-product-form__add-button[data-variant-id="${id}"]`).prop('disabled', true).addClass('added');
      });
    }
    // Run once on page load
    disableAddedVariantButtons();
    
    // Watch the entire body for any DOM changes
    const observer = new MutationObserver(() => {
      if(addedcnt == bundleitemcnt){
        $('.byob-product-item__cta-button').attr("disabled","disabled");
        $('.byob-product-form-qv__add-button').attr("disabled","disabled");
        $('.product-item__quick-buy-button').attr("disabled","disabled");
        $('.collection-byos-atc-button').attr("disabled","disabled");
      }
      disableAddedVariantButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    function activecheck(addedcnt,bundle_price,bundle_compare_price){
      console.log('activecheck',addedcnt);
      var save_percentage = (100 - ((bundle_price * 100) / bundle_compare_price));
      
      $('.bundle-selection-count').html(addedcnt); 
      $('.byob-total-price').html(formatMoney(bundle_price, currencyFormat)); 
      $('.byob-total-compare-price').html(formatMoney(bundle_compare_price, currencyFormat)); 

      if(save_percentage > 0){
        $('.byob-save_percentage').show().html(`(${Math.round(save_percentage)}%)`);    
      }else{
        $('.byob-save_percentage').hide();    
      }
      
      // if(addedcnt == 0){
      //   $('.byob-preview_cart-prices').hide();
      // }else{
      //   $('.byob-preview_cart-prices').show();
      // }
    
      if(addedcnt == bundleitemcnt){
        $('.byob-preview').addClass('stack-full');
        $('.byob-atc_button').removeAttr("disabled");
    
        $('.byob-product-item__cta-button').attr("disabled","disabled");
        $('.byob-product-form-qv__add-button').attr("disabled","disabled");
    
        $('.product-item__quick-buy-button').attr("disabled","disabled");
        $('.collection-byos-atc-button').attr("disabled","disabled");

        $('.byob-preview_cart-prices_qty-show').show();
        $('.byob-preview_cart-prices_default-show').hide();
    
        $('.collection-promotinal-item_button').attr("disabled","disabled");
      }else{
        $('.byob-preview').removeClass('stack-full');
        $('.byob-atc_button').attr("disabled","disabled");
    
        $('.byob-product-item__cta-button').removeAttr("disabled");
        $('.byob-product-form-qv__add-button').removeAttr("disabled");
    
        $('.product-item__quick-buy-button').removeAttr("disabled");
        $('.collection-byos-atc-button').removeAttr("disabled");

        $('.byob-preview_cart-prices_qty-show').hide();
        $('.byob-preview_cart-prices_default-show').show();
    
        $('.collection-promotinal-item_button').removeAttr("disabled");
      }
    }
    
    $('body').on('click','.byob-preview_item-remove_button', function(){
      addedcnt = addedcnt - 1;
      bundle_price = bundle_price - parseInt($(this).closest('.byob-preview_item').attr('data-price'));
      bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.byob-preview_item').attr('data-compare-price'));
      var pid = $(this).closest('.byob-preview_item').attr('data-pid');
      activecheck(addedcnt,bundle_price,bundle_compare_price); 
    
      $(`.product-item[data-product-id="${pid}"]`).find('.byob-product-form__add-button').removeAttr("disabled").removeClass('added');
      $(this).closest('.byob-preview_item').addClass('is-blank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').removeAttr('data-compare-price').find('.byob-preview_item-media').html('<span>Select Item</span>');
    });
    $('body').on('click', '.byob-product-form__add-button', function(e){
      e.preventDefault();
      addedcnt += 1;
      bundle_price += parseInt($(this).attr('data-product-price'));
      bundle_compare_price += parseInt($(this).attr('data-product-compare-price'));
      activecheck(addedcnt,bundle_price,bundle_compare_price);   
    
      $(this).attr("disabled","disabled").addClass('added');
      var featuredimage = $(this).attr('data-featuredimage');
      var itembox = `<img src="${featuredimage}" loading="lazy" width="150" height="150" alt="">`; 
      $('.byob-preview_item.is-blank').first().find('.byob-preview_item-media').html(itembox);
      $('.byob-preview_item.is-blank').first().attr('data-vid',$(this).attr('data-variant-id')).attr('data-pid',$(this).attr('data-product-id')).attr('data-price',$(this).attr('data-product-price')).attr('data-compare-price',$(this).attr('data-product-compare-price')).removeClass('is-blank');    
      $('quick-buy-drawer,quick-buy-popover').removeAttr("open")
    });
    $('body').on('click','.byob-atc_button ', function(){
      $(this).attr("aria-busy",true);
      var items = [];
      var randomId = Math.random().toString(36).substring(2, 12);
      $(this).closest('.byob-preview_main').find('.byob-preview_item:not(.is-blank)').each(function(i,v){
        var val = $(this).attr('data-vid');         
         items.push({
          quantity: 1,
          id: val,
          properties: {
              '_personalize': 'main',
              '_type': 'byob',
              '_bundleid': randomId,
              '_item_count': bundleitemcnt
            }
        });   
      });    
      
      var data = {items};
      console.log('data',data)
      // var data = theme.utils.serialize(this.form);
     
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(data) {      
        $.getJSON("/cart.js", function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart }
          })); 
        });
        document.getElementById('mini-cart').open = true;
        $(this).removeAttr("aria-busy");
      }.bind(this));  
      
    });
    
    $('body').on('click', '.collection-promotinal-item_stack-full-button', function(e){
      $('.stack-full-modal-opener-error').text('Please remove one product from stack to open bundle');
      $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => {
          $('.stack-full-modal-opener-error').removeClass('show');
        }, 2000);
    });
    
    $('body').on('click', '.collection-byob-atc-button', function(e){
      var unfill_stack_count = $('.byob-preview_item.is-blank').length;
      var checkedCount = $(this).closest('.collection-byob-modal').find('.collection-byob-product-item-checkbox:checked').length;
      console.log('000000000',unfill_stack_count,checkedCount);
      if(checkedCount == 0) {
        $('.stack-full-modal-opener-error').text('Please select atleast one item!');
        $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => { $('.stack-full-modal-opener-error').removeClass('show'); }, 2000);
      } else if(unfill_stack_count == 0){
        $('.stack-full-modal-opener-error').text('You have added all three items for Stack. Remove an item to add a new one!');
        $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => { $('.stack-full-modal-opener-error').removeClass('show'); }, 2000);
      } else if(checkedCount > unfill_stack_count){
        $('.stack-full-modal-opener-error').text(`You selected more item. please select ${unfill_stack_count} item to add!`);
        $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => { $('.stack-full-modal-opener-error').removeClass('show'); }, 2000);
      }else {
        $(this).closest('.collection-byob-modal').find('.collection-byob-product-item-checkbox:checked').each(function() {
          addedcnt += 1;
          bundle_price += parseInt($(this).attr('data-product-price'));
          bundle_compare_price += parseInt($(this).attr('data-product-compare-price'));
          activecheck(addedcnt,bundle_price,bundle_compare_price);   
    
          var featuredimage = $(this).attr('data-featuredimage');
          var itembox = `<img src="${featuredimage}" loading="lazy" width="150" height="150" alt="">`; 
          $('.byob-preview_item.is-blank').first().find('.byob-preview_item-media').html(itembox);
          $('.byob-preview_item.is-blank').first().attr('data-vid',$(this).attr('data-variant-id')).attr('data-pid',$(this).attr('data-product-id')).attr('data-price',$(this).attr('data-product-price')).attr('data-compare-price',$(this).attr('data-product-compare-price')).removeClass('is-blank');    
          $('quick-buy-drawer,quick-buy-popover').removeAttr("open")  
        });
        $('modal-content').removeAttr("open");
      }
    });
    
    // BYOB END
    
    // $('body').on('click', '.cart-payment-summary-title', function() {
    //  $('.cart-payment-summary').slideToggle();
    // });
    
    $('body').on('click', '.toggle-term-condition', function() {
      $(this).toggleClass('active');
        $(this).parents('.coupon_offer-item').find('.term-condition_wrapper').toggle();
        if ($(this).hasClass('active')) {
        $(this).text('-hide');
      } else {
        $(this).text('+more');
      }
    });
    
    $('body').on('click', '.cart-offer-coupon_header-coupon-opner', function() {
      $('.cart-cart-coupon_offer-overlay').addClass('show');
    });
    $('body').on('click', '.cart-cart-coupon_offer-popover-close', function() {
      $('.cart-cart-coupon_offer-overlay').removeClass('show');
    });
    // $(document).on('change', '.collection-byob-product-item-checkbox', function() {
    //   var unfill_stack_count = $('.byob-preview_item.is-blank').length;
    //   var checkedCount = $(this).closest('.collection-byob-modal').find('.collection-byob-product-item-checkbox:checked').length;
    //   console.log('Checked count:', checkedCount);
    //   if(checkedCount == 0 || checkedCount > unfill_stack_count) {
    //     $('.collection-byob-atc-button').attr("disabled","disabled");
    //   }
    //   if(checkedCount >= 1 || checkedCount <= unfill_stack_count) {
    //     $('.collection-byob-atc-button').removeAttr("disabled");
    //   }
    // });


    $('.start-selection_button').on('click', function (e) {
      e.preventDefault();
      const offset = window.matchMedia('(max-width: 767px)').matches ? 140 : 320; 
      $('html, body').animate({
        scrollTop: $('.product-list').offset().top-offset
      }, 600);
    });

});
